import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  rootActions: {
    display: "flex",
    justifyContent: "flex-start",
    margin: theme.spacing(2, 0),
    maxWidth: "40%",
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  paper: {
    width: "100%",
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  paperCharts: {
    width: "50%",
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  paperCreatedDay: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  textCoast: { display: "flex", alignItems: "baseline" },
  inputPhone: { marginLeft: `${theme.spacing(2)} !important` },
  imgIcon: { width: theme.spacing(4), height: theme.spacing(4) },
}));
